import React, { FC, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { Connect, PropsFromRedux } from './SearchMainContainer';
import { SearchDrawer } from '../search-drawer/SearchDrawer';
import { SearchSection } from '../search-section/SearchSection';
import { HomeExpired } from '../../../home-expired/HomeExpired';
import styles from './search_main.module.scss';
import { LightHelmet } from '../../../components/light-helmet/LightHelmet';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import { getPageName } from '../../../utils/pageName';
import { SearchLeaveHandler } from '../search-leave/SearchLeaveHandler';
import { PageLayout } from '../../../app/common-app/PageLayout';
import { SearchFiltersBar } from '../search-filters-bar/SearchFiltersBar';
import { useUser } from '../../../user/useUser';
import { Container } from '../../../components/grid/Grid';

type Props = PropsFromRedux;

const RawSearchMain: FC<Props> = ({
  trialExpired,
  quotaExceeded,
  isOpen,
  searchLoading,
  query,
  replaySearch,
}) => {
  const location = useLocation();
  const { search } = location;

  const history = useHistory();
  const {
    loggedIn,
    currentUser: { daysRemaining },
  } = useUser();

  const isExpired = !!loggedIn && daysRemaining === 0;

  useEffect(() => {
    return history.listen(() => {
      if (history.action === 'POP') {
        replaySearch(history.location.search, 'browser_navigation');
      }
    });
  }, [history]);

  useEffect(() => {
    replaySearch(search, 'original_query');
  }, []);

  let title = 'Recherche Doctrine';

  if (quotaExceeded) {
    window.location.href = buildUrlWithParameters('/inscription', {
      source: 'quota-exceeded',
      sourcePage: getPageName(),
    });
  }

  if (trialExpired) {
    title = 'Doctrine - essai terminé';
  } else if (!searchLoading && query) {
    title = `${query} - Recherche Doctrine`;
  }

  return (
    <div
      className={classNames({
        [styles.filtersOpen]: isOpen,
      })}
    >
      <PageLayout subHeader={<SearchFiltersBar />}>
        <LightHelmet title={title} pageName="Search" />
        <Container>
          {!trialExpired && (
            <div
              className={classNames(styles.searchContainer, {
                filter__mobile__shown: isOpen,
              })}
            >
              {isOpen && <SearchDrawer />}

              <SearchSection />
            </div>
          )}
          <SearchLeaveHandler />
          {isExpired && <HomeExpired />}
        </Container>
      </PageLayout>
    </div>
  );
};

export const SearchMain = Connect(RawSearchMain);

export default SearchMain;
